import * as OAuth2AccessTokenOperations from './operations';

export {
    OAuth2AccessTokenOperations
};